export default "__VITE_ASSET__BMBkAf4s__"